import { API_ROUTE } from "../constants/workerConstants";
import AxiosInstance from "./http.handlers";

export const GetMmDevices = async (headers) => {
  return await AxiosInstance.get(`${API_ROUTE.MMDEVICES.CRUD_DEVICES}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const GetDevicesType = async (headers) => {
  return await AxiosInstance.get(`${API_ROUTE.MMDEVICES.DEVICE_TYPE}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const CreateMmDevice = async (payload, headers) => {
  return await AxiosInstance.post(
    `${API_ROUTE.MMDEVICES.CRUD_DEVICES}`,
    payload,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};

export const GetMmDevice = async (id, headers) => {
  return await AxiosInstance.get(`${API_ROUTE.MMDEVICES.CRUD_DEVICES}/${id}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const updateMmDevice = async (id, payload, headers) => {
  return await AxiosInstance.put(
    `${API_ROUTE.MMDEVICES.CRUD_DEVICES}/${id}`,
    payload,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};
